<template>
    <div class="animated fadeIn">
        <LoadingWidget
            v-if="initStatus != 1"
            :status="initStatus"
            @init="init"
        />

        <b-card v-else>
            <h5 class="mb-0">
                <i class="fa fa-fw fa-archive mr-2" />Daftar Titip Jual
            </h5>
            <hr />
            <b-row class="mb-3">
                <b-col md="6" lg="5">
                    <b-form-group label="Kode Titip Jual" class="mb-0">
                        <b-input-group>
                            <b-form-input
                                v-model="filter.code"
                                maxlength="50"
                                @keydown.enter="getItems"
                                placeholder="Cari Kode Titip Jual..."
                            />
                            <b-input-group-append>
                                <b-button variant="primary" @click="getItems">
                                    <i class="fa fa-search mr-2" />Cari
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-table
                bordered
                hover
                show-empty
                no-local-sorting
                :busy="isBusy"
                :items="items"
                :fields="fields"
                @sort-changed="onSortChanged"
                responsive
                class="mb-3"
            >
                <template v-slot:empty>
                    Tidak ada data Kirim Invent.
                </template>
                <template v-slot:cell(created_at)="row">
                    {{ parseDate(row.item.created_at) }}
                </template>
                <template v-slot:cell(action)="row">
                    <router-link
                        :to="'/barang-masuk/titip-jual/' + row.item.id"
                    >
                        <b-button
                            size="sm"
                            variant="primary"
                            v-b-tooltip.hover.top
                            title="Detail Titip Jual"
                        >
                            <i class="fa fa-fw fa-info" />
                        </b-button>
                    </router-link>
                </template>
            </b-table>
            <PageSizer
                :totalRows="totalRows"
                :page="currentPage"
                :options="options"
                @limit-change="onLimitChange"
                @page-change="onPageChange"
            />
        </b-card>
    </div>
</template>

<script>
export default {
    data() {
        return {
            initStatus: 0,
            isBusy: true,
            isSubmitting: false,

            filter: {
                code: ""
            },

            options: [
                { value: 10, text: "10" },
                { value: 20, text: "20" },
                { value: 30, text: "30" },
                { value: 40, text: "40" },
                { value: 50, text: "50" }
            ],

            fields: [
                { key: "code", label: "Kode Titip Jual", sortable: false },
                { key: "total_item", label: "Total Barang", sortable: false },
                {
                    key: "approved_item",
                    label: "Barang Disetujui",
                    sortable: false
                },
                { key: "created_at", label: "Tanggal Dibuat", sortable: false },
                { key: "action", label: "Aksi", sortable: false }
            ],

            items: [],
            currentPage: 1,
            perPage: 10,
            totalRows: 0
        };
    },

    methods: {
        init() {
            this.initStatus = 0;
            this.getItems();
            this.initStatus = 1;
        },

        getItems(page = 1) {
            this.isBusy = true;
            this.items = [];

            if (isNaN(page)) {
                this.currentPage = 1;
            } else {
                this.currentPage = page;
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(
                this.currentPage,
                this.perPage,
                true
            );

            if (this.filter.code) {
                param += `&code=${this.filter.code}`;
            }

            return this.$axios
                .get("consignment" + param)
                .then(res => {
                    this.items = res.data.data.items;
                    this.totalRows = res.data.data.total;
                })
                .catch(error => {
                    this.$helper.parseError(this, error);
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage;
            this.getItems(this.currentPage);
        },

        onPageChange(newPage) {
            this.currentPage = newPage;
            this.getItems(this.currentPage);
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy;
            this.sortDesc = ctx.sortDesc;
            this.getItems();
        },

        parseDate(date) {
            if (!date) return "-";

            return `${this.$helper.parseDate(
                date
            )}, ${this.$helper.parseHourMinute(date)}`;
        }
    },

    created() {
        this.init();
        this.$helper.toastFlash(this);
    }
};
</script>
